class CartDrawer extends HTMLElement{
  connectedCallback(){
    this.overlay=this.querySelector('.cart-drawer__overlay');
    this.closeBtns=this.querySelectorAll('[data-cart-close]');
    this.openBtns=document.querySelectorAll('[data-cart-open]');
    this.overlay?.addEventListener('click',()=>this.close());
    this.closeBtns.forEach(b=>b.addEventListener('click',()=>this.close()));
    this.openBtns.forEach(b=>b.addEventListener('click',(e)=>{e.preventDefault();this.open();}));
    document.addEventListener('keydown',(e)=>{if(e.key==='Escape')this.close();});
    this.addEventListener('change',(e)=>{
      if(e.target.matches('[data-line-key]')){
        const q=Math.max(0,parseInt(e.target.value,10)||0);
        fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:e.target.dataset.lineKey,quantity:q})}).then(()=>this.refresh()).catch(()=>{});
        return;
      }
      if(e.target.matches('[data-cart-note]'))fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:e.target.value})}).catch(()=>{});
    });
    document.addEventListener('submit',(e)=>{
      const form=e.target;
      if(form.tagName==='FORM' && form.getAttribute('action')?.includes('/cart/add')){
        e.preventDefault();
        this.addItem(form);
      }
    });
  }
  open(){this.classList.add('is-open');document.body.style.overflow='hidden';}
  close(){this.classList.remove('is-open');document.body.style.overflow='';}
  addItem(form){
    const returnToEl=form.querySelector('[data-return-to]');
    const buyNow=!!returnToEl&&returnToEl.value==='/checkout';
    if(returnToEl)returnToEl.value='';
    const formData=new FormData(form);
    const extras=[];
    form.querySelectorAll('[data-addon-check]:checked').forEach(ch=>{
      if(!ch.dataset.variantId)return;
      const item={id:Number(ch.dataset.variantId),quantity:1};
      if(ch.dataset.sellingPlan)item.selling_plan=Number(ch.dataset.sellingPlan);
      extras.push(item);
    });
    form.querySelectorAll('[data-addon-row][data-mode="check"]').forEach(row=>{
      const q=parseInt(row.querySelector('[data-qty-val]').textContent,10)||0;
      if(q>0&&row.dataset.variantId)extras.push({id:Number(row.dataset.variantId),quantity:q});
    });
    fetch('/cart/add.js',{method:'POST',body:formData})
      .then(r=>r.json())
      .then(()=>extras.length?fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:extras})}):null)
      .then(()=>buyNow?(window.location.href='/checkout'):this.refresh().then(()=>this.open()))
      .catch(()=>{});
  }
  refresh(){
    return fetch('/cart?view=drawer')
      .then(r=>r.text())
      .then(html=>{
        const doc=new DOMParser().parseFromString(html,'text/html');
        const newBar=doc.querySelector('.free-shipping-bar');
        const bar=this.querySelector('.free-shipping-bar');
        if(newBar&&bar)bar.innerHTML=newBar.innerHTML;
        const newItems=doc.querySelector('.cart-drawer__items');
        const newFooter=doc.querySelector('.cart-drawer__footer');
        if(newItems)this.querySelector('.cart-drawer__items').innerHTML=newItems.innerHTML;
        if(newFooter)this.querySelector('.cart-drawer__footer').innerHTML=newFooter.innerHTML;
      }).catch(()=>{});
  }
}
customElements.define('cart-drawer',CartDrawer);
